import { Exclude } from "class-transformer";
import { computed, observable } from "mobx";
import type { EntityValidationRules } from "services/validationService";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export class MonthOfYearOpenRangeRequest {
  @observable
  fromYear?: number;

  @observable
  fromMonth?: number;

  @observable
  toYear?: number;

  @observable
  toMonth?: number;
}

export default class MonthOfYearRangeRequest extends MonthOfYearOpenRangeRequest {
  @Exclude()
  @observable
  fromState?: string;

  @Exclude()
  @observable
  toState?: string;

  @computed
  get from() {
    return this.fromState;
  }

  set from(from: string | undefined) {
    if (from) {
      const year = from.split("-")[0];
      const month = from.split("-")[1];

      this.fromYear = parseInt(year);
      this.fromMonth = parseInt(month);
    } else {
      this.fromYear = undefined;
      this.fromMonth = undefined;
    }

    this.fromState = from;
  }

  @computed
  get to() {
    return this.toState;
  }

  set to(to: string | undefined) {
    if (to) {
      const year = to.split("-")[0];
      const month = to.split("-")[1];

      this.toYear = parseInt(year);
      this.toMonth = parseInt(month);
    } else {
      this.toYear = undefined;
      this.toMonth = undefined;
    }

    this.toState = to;
  }
}

export const RequiredMonthOfYearOpenRangeValidationRules: EntityValidationRules<MonthOfYearRangeRequest> = {
  from: {
    required: true,
  },
  to: {
    required: true,
  },
};
